import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function pervalOrganizationCodeValidator(): ValidatorFn {
  const regex = /^[A-Z0-9]+$/;

  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const valid = regex.test(control.value);
    return valid ? null : { invalidCode: true };
  };
}
